import React, { useState } from "react";

import { Modal, Button } from "antd";
import { toast } from "react-toastify";

import CardStepper from "../../../Common/UIComponents/CardStepper";

import { setSmartRandomizer } from "../../../../actions/envAnalytics";

import "./SwabLimitModal.css";

const SwabLimitModal = ({
  onClose, randomizerPayload, setSubmissionCategory, fetchEnvScheduleData, submissionCategory,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [swabLimit, setSwabLimit] = useState(randomizerPayload?.max_swabs_pd || 1);

  /**
   * Submit the swab limit and close the modal
   * @param {object} payload - The new swab limit value
   */

  const handleFinish = async () => {
    setIsLoading(true);
    // Add specific fields based on the testing strategy
    const payload = { ...randomizerPayload };

    // Add mandatory fields to the payload
    payload.max_swabs_pd = swabLimit;
    try {
      // Call the setSmartRandomizer API
      const response = await setSmartRandomizer(payload);

      if (response.success) {
        // toast.success("Smart Randomizer setup successfully!");
        onClose();
        if (submissionCategory === "") {
          fetchEnvScheduleData();
          return;
        }
        setSubmissionCategory("");
        toast.success("View Priority Scores in Analytics");
      } else if (response.message === "Daily limit exceed") {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Failed to update daily limit.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open
      centered
      // onCancel={onClose}
      width={520}
      className="SwabLimitModal"
      wrapClassName="SwabLimitModal__Wrap"
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      title={null}
    >
      <div className="SwabLimitModal__Header">
        Daily Limit Exceeded
      </div>
      <div className="SwabLimitModal__Content">
        <div className="SwabLimitModal__TextContainer">
          <div className="SwabLimitModal__Description">
            The number of swabs exceeds your current daily limit. Please increase the daily limit to proceed.
          </div>
        </div>
        <CardStepper
          min={1}
          max={100}
          value={swabLimit}
          onChange={(value) => setSwabLimit(value)}
          hasError
        />
      </div>
      <div className="SwabLimitModal__ButtonContainer">
        <Button
          htmlType="button"
          type="default"
          onClick={() => {
            onClose();
            fetchEnvScheduleData();
          }}
        >
          Cancel
        </Button>
        <Button
          htmlType="button"
          type="primary"
          className="SwabLimitModal__UpdateBtn"
          onClick={handleFinish}
          loading={isLoading}
        >
          Update
        </Button>
      </div>
    </Modal>
  );
};

export default SwabLimitModal;
